import React, { useRef, useState } from "react"
import Displaybox from "./DisplayBox"
import { Paper} from '@mui/material'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import {DataPoint} from '../../Pages/Historic'

export interface FocusedProps{
    data: DataPoint,
    tags: string[],
    defaultFocused?: Set<string>

}
function titleFromTag(tag:string):string{
    switch(tag){
        case 't_inlet_m':
            return 'Temperature';
        case 'rho_e_m':
            return 'Density'
        case 'a_api_3rpm_e':
            return '3 RPM'
        case 'a_api_6rpm_e':
            return '6 RPM'
        case 'a_api_100rpm_e':
            return '100 RPM'
        case 'a_api_200rpm_e':
            return '200 RPM'
        case 'a_api_300rpm_e':
            return '300 RPM'
        case 'a_api_600rpm_e':
            return '600 RPM'
        case 'my_api_pv_e':
            return 'Plastic Viscosity'
        case 'my_api_yp_e':
            return 'Yield Point'

        default:
            return tag
    }
}
function unitFromTag(tag:string):string{
    switch(tag){
        case 't_inlet_m':
            return 'Celsius';
        case 't_f_inlet_m':
            return 'Fahrenheit';
        case 'rho_e_m':
            return 'SG'
        case 'rho_e_m_PPG':
            return 'PPG'
        case 'my_api_pv_e':
            return 'cP'
        case 'my_api_yp_e':
            return 'lb/100ft2'
        default:
            return ''
    }
}
function handleCheckboxChange(tag:string, focused:Set<string>, setFocused:React.Dispatch<React.SetStateAction<Set<string>>>){
    const newFocused = new Set(focused)
    if(newFocused.has(tag)){
        newFocused.delete(tag)
    }else{
        newFocused.add(tag)
    }
    setFocused(newFocused)
}
function createCheckboxes(tags:string[], focused:Set<string>, setFocused:React.Dispatch<React.SetStateAction<Set<string>>>){
    return tags.map((tag)=>{
        return(
            <FormControlLabel control={<Checkbox onChange={(e) => handleCheckboxChange(tag, focused, setFocused)} sx={{color:'white'}} defaultChecked={focused.has(tag)} />} label={tag} sx={{color:'white'}}/>
        )
    })
}
function Focused(props:FocusedProps){
    const {data, tags, defaultFocused} = props
    const [focused, setFocused] = useState(new Set<string>(defaultFocused || ['t_inlet_m','rho_e_m']))
    const id = React.useId();
return(
    <Paper elevation={10} sx={{display:'flex', flexDirection:'column', flexWrap:'wrap', columnGap:1, justifyContent:'flex-start', pb:'30px',pr:'20px',mr:'20px', mt: '30px',ml:'20px', backgroundColor:'#273746'}}>
        <Accordion style={{'backgroundColor':'#273746'}}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{color:'white'}} />}
          aria-controls={`${id}-panel1-content`}
          id={`${id}-panel1-header`}
        >
          <h1 style={{color:'white'}}>Focused</h1>
        </AccordionSummary>
        <AccordionDetails>
           <FormGroup>
                {createCheckboxes(tags, focused, setFocused)}
            </FormGroup>
        </AccordionDetails>
      </Accordion>
    
        
        {Array.from(focused).map((tag)=>{
            return(
                <Displaybox data={data[tag]} title={titleFromTag(tag)} unit={unitFromTag(tag)}/>
            )
        })}
    </Paper>
)
}

export default Focused